const AUTH_STORAGE_KEY = 'stratitude_share_auth'
const EMAIL_STORAGE_KEY = 'stratitude_share_last_email'

export function readAuth() {
  var saved = sessionStorage.getItem(AUTH_STORAGE_KEY) || localStorage.getItem(AUTH_STORAGE_KEY)

  if (!saved) {
    return null
  }

  try {
    var auth = JSON.parse(saved)

    if (!auth || !auth.token || !auth.email) {
      clearAuth()
      return null
    }

    if (auth.expires_at && Date.now() >= Number(auth.expires_at)) {
      clearAuth()
      return null
    }

    var normalized = JSON.stringify(auth)
    sessionStorage.setItem(AUTH_STORAGE_KEY, normalized)
    localStorage.setItem(AUTH_STORAGE_KEY, normalized)
    return auth
  } catch (error) {
    clearAuth()
    return null
  }
}

export function saveAuth(token, email, expiresAt) {
  var auth = {
    token: token,
    email: email,
    expires_at: expiresAt
  }
  var saved = JSON.stringify(auth)

  sessionStorage.setItem(AUTH_STORAGE_KEY, saved)
  localStorage.setItem(AUTH_STORAGE_KEY, saved)
  localStorage.setItem(EMAIL_STORAGE_KEY, email)
  return auth
}

export function clearAuth() {
  sessionStorage.removeItem(AUTH_STORAGE_KEY)
  localStorage.removeItem(AUTH_STORAGE_KEY)
}

export function readLastEmail() {
  return localStorage.getItem(EMAIL_STORAGE_KEY) || ''
}
